function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2651",
  "data-name": "Group 2651",
  transform: "translate(-2.998 -2.998)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4203",
  "data-name": "Path 4203",
  d: "M13.011,3A10.013,10.013,0,1,0,23.024,13.011,10.024,10.024,0,0,0,13.011,3Zm0,18.485a8.473,8.473,0,1,1,8.473-8.473A8.483,8.483,0,0,1,13.011,21.483Z",
  transform: "translate(0 0)",
  fill: "#f6c244"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4204",
  "data-name": "Path 4204",
  d: "M14.407,7h0a.77.77,0,0,0-.77.769l-.012,5.391H9.772a.77.77,0,1,0,0,1.54h4.619a.77.77,0,0,0,.77-.769l.014-6.159A.77.77,0,0,0,14.407,7Z",
  transform: "translate(-1.38 -0.921)",
  fill: "#f6c244"
}));

var SvgTime = function SvgTime(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.026,
    height: 20.026,
    viewBox: "0 0 20.026 20.026",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTime, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/time.d251271e.svg";
export { ForwardRef as ReactComponent };